var map = {
	"./Download/Account.svg": 88043,
	"./Download/Authority.svg": 2845,
	"./Download/Combo.svg": 23960,
	"./Download/Directory.svg": 81967,
	"./Download/Employee.svg": 28614,
	"./Download/Flag.svg": 75296,
	"./Download/Food.svg": 83130,
	"./Download/Freight.svg": 90411,
	"./Download/Function.svg": 59678,
	"./Download/Invisible.svg": 3127,
	"./Download/KDS.svg": 60946,
	"./Download/Label.svg": 14436,
	"./Download/Pay.svg": 18600,
	"./Download/Pickup.svg": 32374,
	"./Download/Promotion.svg": 18693,
	"./Download/Sequence.svg": 21645,
	"./Download/Taste.svg": 35559,
	"./Download/Warehouse.svg": 11735,
	"./Icon/Add.svg": 22312,
	"./Icon/Alert.svg": 73615,
	"./Icon/ArrowFatLinesRight.svg": 24582,
	"./Icon/ArrowFatLinesRight_S.svg": 48628,
	"./Icon/ArrowRight.svg": 136,
	"./Icon/BackgroundColor.svg": 74836,
	"./Icon/BatchNumber.svg": 76498,
	"./Icon/Calendar.svg": 39577,
	"./Icon/Calendar_blue.svg": 46080,
	"./Icon/Camera.svg": 96822,
	"./Icon/Cancel.svg": 95197,
	"./Icon/Checked.svg": 91278,
	"./Icon/Clock.svg": 77915,
	"./Icon/Close.svg": 53261,
	"./Icon/Decrease.svg": 17447,
	"./Icon/Diamond.svg": 63681,
	"./Icon/Download.svg": 80599,
	"./Icon/DownloadTerminalCheck.svg": 1753,
	"./Icon/Download_gray.svg": 42295,
	"./Icon/DropDownAngle.svg": 87693,
	"./Icon/DropDownArrow.svg": 35871,
	"./Icon/EatType.svg": 98235,
	"./Icon/Edit.svg": 82975,
	"./Icon/Eye.svg": 40426,
	"./Icon/FlowerCurrency.svg": 86643,
	"./Icon/FontColor.svg": 54625,
	"./Icon/FontSize.svg": 57103,
	"./Icon/Function.svg": 92207,
	"./Icon/Image.svg": 61986,
	"./Icon/Increase.svg": 18059,
	"./Icon/Information.svg": 50123,
	"./Icon/InnerScrollArrowLeft.svg": 82762,
	"./Icon/InnerScrollArrowRight.svg": 57281,
	"./Icon/JumpMax.svg": 78039,
	"./Icon/JumpOnce.svg": 60656,
	"./Icon/Label.svg": 85043,
	"./Icon/Line.svg": 75913,
	"./Icon/ListToggle.svg": 13207,
	"./Icon/Menu.svg": 17186,
	"./Icon/Next.svg": 9564,
	"./Icon/OnlineOrder.svg": 34514,
	"./Icon/OnlineOrderMenu.svg": 9859,
	"./Icon/Pay.svg": 98135,
	"./Icon/Previous.svg": 66164,
	"./Icon/Printer.svg": 2025,
	"./Icon/PromotionType.svg": 54586,
	"./Icon/Question.svg": 91347,
	"./Icon/Receipt.svg": 94637,
	"./Icon/Search_gray.svg": 3943,
	"./Icon/Search_white.svg": 26001,
	"./Icon/Setting.svg": 63861,
	"./Icon/Specification.svg": 97898,
	"./Icon/Stock.svg": 15571,
	"./Icon/Table.svg": 12425,
	"./Icon/TableSortArrow.svg": 41128,
	"./Icon/TriangleDown.svg": 33091,
	"./Icon/Warning.svg": 865,
	"./Icon/Warning_gray.svg": 8377,
	"./Instruction/PromotionModeType.jpg": 15324,
	"./LineOA/Background/Black-Four.jpg": 32017,
	"./LineOA/Background/Black-One.jpg": 87129,
	"./LineOA/Background/Black-Six.jpg": 83617,
	"./LineOA/Background/Gray-Four.jpg": 70557,
	"./LineOA/Background/Gray-One.jpg": 9453,
	"./LineOA/Background/Gray-Six.jpg": 28701,
	"./LineOA/Background/White-Four.jpg": 77243,
	"./LineOA/Background/White-One.jpg": 86243,
	"./LineOA/Background/White-Six.jpg": 88303,
	"./LineOA/Button/BuyList-Black.svg": 46267,
	"./LineOA/Button/BuyList-White.svg": 90977,
	"./LineOA/Button/Deposit-Black.svg": 54589,
	"./LineOA/Button/Deposit-White.svg": 31363,
	"./LineOA/Button/GiftVoucher-Black.svg": 42703,
	"./LineOA/Button/GiftVoucher-White.svg": 66853,
	"./LineOA/Button/HistoryOrder-Black.svg": 4889,
	"./LineOA/Button/HistoryOrder-White.svg": 90127,
	"./LineOA/Button/MemberLevel-Black.svg": 4395,
	"./LineOA/Button/MemberLevel-White.svg": 63057,
	"./LineOA/Button/MemberProfolio-Black.svg": 53743,
	"./LineOA/Button/MemberProfolio-White.svg": 98117,
	"./LineOA/Button/MemberWeb-Black.svg": 38731,
	"./LineOA/Button/MemberWeb-White.svg": 13745,
	"./LineOA/Button/OrderNow-Black.svg": 95457,
	"./LineOA/Button/OrderNow-White.svg": 42711,
	"./LineOA/Button/Point-Black.svg": 36353,
	"./LineOA/Button/Point-White.svg": 83607,
	"./LineOA/Button/Prepaid-Black.svg": 11786,
	"./LineOA/Button/Prepaid-White.svg": 6160,
	"./LineOA/Button/Profolio-Black.svg": 51029,
	"./LineOA/Button/Profolio-White.svg": 89275,
	"./LineOA/Button/TrackOrder-Black.svg": 12282,
	"./LineOA/Button/TrackOrder-White.svg": 43968,
	"./LineOA/Management/Company.png": 61043,
	"./LineOA/Management/OK.svg": 61698,
	"./LineOA/Management/Store.png": 90717,
	"./Login/Ushow_banner.png": 79222,
	"./Login/Ushow_logo.svg": 66429,
	"./Login/Ushow_slogan.svg": 82090,
	"./Logo/LogoCircle.png": 27734,
	"./Message/alert.png": 25425,
	"./Message/confirm.png": 27283,
	"./Message/error.png": 97409,
	"./Message/success.png": 72298,
	"./Navbar/Account.svg": 44357,
	"./Navbar/Account_active.svg": 82702,
	"./Navbar/Basic.svg": 28730,
	"./Navbar/Basic_active.svg": 98039,
	"./Navbar/Combination.svg": 47565,
	"./Navbar/Combination_active.svg": 64614,
	"./Navbar/Download.svg": 86040,
	"./Navbar/Download_active.svg": 7005,
	"./Navbar/ERP.svg": 11703,
	"./Navbar/ERP_active.svg": 20848,
	"./Navbar/Member.svg": 77814,
	"./Navbar/Member_active.svg": 67163,
	"./Navbar/Module.svg": 12512,
	"./Navbar/Module_active.svg": 73845,
	"./Navbar/Notify.svg": 37259,
	"./Navbar/OnlineOrder.svg": 38151,
	"./Navbar/OnlineOrder_active.svg": 42912,
	"./Navbar/Report.svg": 12814,
	"./Navbar/Report_active.svg": 56259,
	"./Navbar/Return.svg": 18458,
	"./Navbar/Ushow_logo.svg": 61600,
	"./QRcode/Blue.png": 37178,
	"./QRcode/Green.png": 45753,
	"./QRcode/Orange.png": 89492,
	"./QRcode/Purple.png": 3676,
	"./QRcode/Red.png": 41433,
	"./Shortcut/Account.svg": 66101,
	"./Shortcut/Basic.svg": 46986,
	"./Shortcut/Customer.svg": 11600,
	"./Shortcut/ERP.svg": 80647,
	"./Shortcut/OnlineOrder.svg": 73079,
	"./Shortcut/Report.svg": 70302,
	"./Tools/API.svg": 87045,
	"./Tools/Add.svg": 59396,
	"./Tools/AddCircle.svg": 18296,
	"./Tools/Arrange.svg": 90885,
	"./Tools/ArrowDown.svg": 11834,
	"./Tools/ArrowToggle.svg": 66810,
	"./Tools/ArrowUp.svg": 9801,
	"./Tools/Back.svg": 57550,
	"./Tools/Bag.svg": 96603,
	"./Tools/Balance.svg": 79449,
	"./Tools/Burger.svg": 72256,
	"./Tools/Cancel.svg": 95433,
	"./Tools/CheckList.svg": 42573,
	"./Tools/Coin.svg": 8060,
	"./Tools/ColumnPropertySetting.svg": 60046,
	"./Tools/Copy.svg": 14580,
	"./Tools/DWAPI.svg": 55348,
	"./Tools/Done.svg": 25531,
	"./Tools/Down.svg": 64511,
	"./Tools/Edit.svg": 98011,
	"./Tools/Export.svg": 23969,
	"./Tools/File.svg": 20465,
	"./Tools/Glasses.svg": 67913,
	"./Tools/Go.svg": 68793,
	"./Tools/Hide.svg": 67735,
	"./Tools/History.svg": 56829,
	"./Tools/Image.svg": 65926,
	"./Tools/Import.svg": 75332,
	"./Tools/Invoice.svg": 68320,
	"./Tools/KDS.svg": 19657,
	"./Tools/Key.svg": 80924,
	"./Tools/Label.svg": 79911,
	"./Tools/Language.svg": 78057,
	"./Tools/License.svg": 87956,
	"./Tools/List.svg": 71563,
	"./Tools/Lock.svg": 4078,
	"./Tools/Manual.svg": 81265,
	"./Tools/MeepShop.svg": 31754,
	"./Tools/More.svg": 50288,
	"./Tools/MoveIn.svg": 53465,
	"./Tools/MoveOut.svg": 89768,
	"./Tools/MoveToLeft.svg": 54504,
	"./Tools/MoveToRight.svg": 20471,
	"./Tools/PDF.svg": 23391,
	"./Tools/Printer.svg": 17917,
	"./Tools/Purchase.svg": 40846,
	"./Tools/QRcode.svg": 70021,
	"./Tools/Record.svg": 73532,
	"./Tools/Redo.svg": 92723,
	"./Tools/Remove.svg": 17159,
	"./Tools/Report.svg": 52089,
	"./Tools/Return.svg": 43389,
	"./Tools/Send.svg": 79885,
	"./Tools/Sequence.svg": 75128,
	"./Tools/Setting.svg": 39769,
	"./Tools/Show.svg": 18092,
	"./Tools/SpecialAdd.svg": 31137,
	"./Tools/Specification.svg": 52110,
	"./Tools/SpecificationModule.svg": 87530,
	"./Tools/Stamp.svg": 45780,
	"./Tools/Sync.svg": 39526,
	"./Tools/Table.svg": 57309,
	"./Tools/Terminal.svg": 12827,
	"./Tools/Transfer.svg": 29266,
	"./Tools/Txt.svg": 1741,
	"./Tools/Unbind.svg": 30659,
	"./Tools/Unlock.svg": 58623,
	"./Tools/Up.svg": 19600,
	"./Tools/Upload.svg": 24108,
	"./Tools/Uturn.svg": 56125,
	"./Tools/View.svg": 18664,
	"./Tools/XLS.svg": 8370
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31621;